module.exports = __webpack_public_path__ + "sb.svg?6899771fe71246ff7b4c91223f9e8f2f";